export const namespaced = true

export const getters = {
	store_permissions: () => {
		return [
			{ name: 'Admin', value: 'admin' },
			{ name: 'Editor', value: 'editor' },
		]
	},
}